/** Notes d'un incident à la longueur des critères de la 3A : cinq, six quand le profil du chef ENI est allumé
 *  (registre D18). Une note absente vaut 0 (non noté) ; une note de trop, d'un mode éteint depuis, est ignorée. */
export function paddedRatings(values: readonly number[] | undefined, count: number): number[] {
  return Array.from({ length: count }, (_, k) => values?.[k] ?? 0);
}
